import React, { useState } from 'react';
import {
  HomefieldIconChevronLeft,
  HomefieldIconChevronRight,
} from '@dsg-tech/homefield-react-icons';
import type { SlideinNavSMLink } from 'types';
import { Button, Drawer } from '@dsg-tech/homefield-react';
import './SlideinNavSM.scss';

interface SubNavProps {
  links: SlideinNavSMLink;
}

const formatDataEm = (text: string) => {
  return `TopNav_${text.replace(/\s/g, '')}`;
};

const SubNav = ({ links }: SubNavProps) => {
  return (
    <div>
      {links.cta.map((category) => (
        <a key={category.link} href={category.link} className="hmf-text-decoration-none">
          <button
            type="button"
            data-em={formatDataEm(category.linkTitle)}
            className="option hmf-display-flex hmf-align-items-center hmf-justify-content-between hmf-px-s">
            <p className="option-text hmf-body-bold-l hmf-m-0">{category.linkTitle}</p>
          </button>
        </a>
      ))}
    </div>
  );
};

interface SlideinNavSMProps {
  open: boolean;
  closeHandler: () => void;
  headerNavLinks?: SlideinNavSMLink[];
}

export default function SlideinNavSM({
  open,
  closeHandler,
  headerNavLinks,
}: Readonly<SlideinNavSMProps>) {
  const [currentNav, setCurrentNav] = useState<SlideinNavSMLink | null>(null);

  return (
    <Drawer
      onCloseModal={closeHandler}
      className="slidein-nav-sm"
      open={open}
      direction="left"
      mobilePeek={false}>
      <div className="slidein-nav hmf-position-fixed hmf-display-block hmf-display-m-none hmf-w-100 hmf-h-100">
        <div className="slidein-nav-header hmf-display-flex hmf-w-100">
          {currentNav && (
            <Button
              variant="tertiary"
              icon={<HomefieldIconChevronLeft />}
              className="slidein-nav-header-back-btn hmf-py-0 hmf-px-0"
              onClick={() => setCurrentNav(null)}
              aria-label="go back button"
              label="Back button"
              data-testid="back-button"
            />
          )}
          <p
            className={`${
              currentNav ? '' : 'hmf-pl-s'
            } slidein-nav-header-title hmf-header-bold-m hmf-display-flex hmf-justify-content-center hmf-align-items-center hmf-m-0`}>
            {currentNav ? currentNav.title : 'Menu'}
          </p>
        </div>
        <nav className="slidein-nav-options">
          {!currentNav &&
            headerNavLinks?.map((nav) => (
              <button
                key={nav.title}
                type="button"
                onClick={() => setCurrentNav(nav)}
                data-em={formatDataEm(nav.title)}
                className="option hmf-display-flex hmf-align-items-center hmf-justify-content-between hmf-px-s">
                <p className="option-text hmf-body-bold-l hmf-m-0">{nav.title}</p>
                <HomefieldIconChevronRight width={16} height={16} />
              </button>
            ))}

          {currentNav && <SubNav links={currentNav} />}
        </nav>
      </div>
    </Drawer>
  );
}
